export const getAuthToken = () => localStorage.getItem('token');

export const setAuthToken = (token) => {
  if (token) localStorage.setItem('token', token);
  else localStorage.removeItem('token');
};
